import { TextField } from "@mui/material";
import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";

import { SearchIcon } from "@/icons";
import theme from "@/theme";

interface AssetSearchInputProps {
  value: string;
  onDebouncedChange: (value: string) => void;
  debounceMs?: number;
}

export function AssetSearchInput({
  value,
  onDebouncedChange,
  debounceMs = 500,
}: AssetSearchInputProps) {
  const [local, setLocal] = useState(value);

  useEffect(() => {
    setLocal(value);
  }, [value]);

  const debounced = useMemo(
    () => debounce(onDebouncedChange, debounceMs),
    [onDebouncedChange, debounceMs],
  );

  useEffect(() => () => debounced.cancel(), [debounced]);

  return (
    <TextField
      variant="outlined"
      size="small"
      slotProps={{
        root: { sx: { width: "100%" } },
        input: {
          startAdornment: <SearchIcon sx={{ marginRight: theme.spacing(4) }} />,
          placeholder: "Search by asset name",
          value: local,
          onChange: (ev) => {
            setLocal(ev.target.value);
            debounced(ev.target.value);
          },
        },
      }}
    />
  );
}
